import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

import { Box } from '@mui/material';

import ChipCounter from '../ChipCounter';

const REFERENCE_TYPES = [
    'canvas',
    'd2',
    'dsquare',
    'exploitdb',
    'exploitpack',
    'metasploit',
    'packetstorm',
    'pwnmalw',
    'saint',
    'seebug',
    'vulnerlab',
    'zdt',
    'zeroscience'
];

const ExactMatchList = ({ data }) => {
    const { references, affectedSoftware, affectedPackages, affectedConfiguration, enchantments } = data;

    // TODO Get from stats
    const exploits = useMemo(() => {
        const { dependencies = {} } = enchantments || {};
        const { references = [] } = dependencies || {};
        return references.reduce(
            (acc, { type, idList }) => (REFERENCE_TYPES.includes(type) ? acc + idList.length : acc),
            0
        );
    }, [enchantments]);

    return (
        <Box display="flex" flexDirection="row" flexWrap={'wrap'}>
            <ChipCounter label="Exploits" data={exploits} />
            <ChipCounter label="References" data={references} />
            <ChipCounter label="Affected Software" data={affectedSoftware} />
            <ChipCounter label="Affected Packages" data={affectedPackages} />
            <ChipCounter label="Affected Configuration" data={affectedConfiguration} />
        </Box>
    );
};

ExactMatchList.propTypes = {
    data: PropTypes.object
};

export default ExactMatchList;
